import React from 'react';
import { TemplateType } from '../TemplateType';
import usePdfContent, { PdfContentParams } from '../usePdfContent';
import { useLocation } from 'react-router-dom';
import { makePath } from 'apps/Pdf/helpers/helpers';

import PdfContent from 'apps/Pdf/components/common/PdfContent';
import Title from 'apps/Pdf/components/common/Title';
import BasicData from 'apps/Pdf/components/BasicData/BasicData';
import H3 from 'apps/Pdf/components/common/H3';
import H2 from 'apps/Pdf/components/common/H2';
import Signature from 'apps/Pdf/components/Signature/Signature';
import Loading from 'apps/Pdf/components/common/Loading';
import Spacer from 'apps/Pdf/components/common/Spacer';
import P from 'apps/Pdf/components/common/P';

import PersonalData from 'apps/Pdf/templates/MainContract/components/PersonalData';
import CompanyData from 'apps/Pdf/templates/MainContract/components/CompanyData';
import BankAccounts from 'apps/Pdf/templates/MainContract/components/BankAccounts';

import useColorStyles from 'apps/Pdf/styles/colors';
import { PersonalDataInterface } from './PersonalDataInterface';
import { PersonType } from 'enums';
import { ContractPhysicalData, ContractLegalData } from 'stores/workflowStores/workflowPersonalDataStore/model';
import { PdfCategory } from '../Interfaces';

const NewPersonalData = (params: PdfContentParams) => {
  const location = useLocation();
  const pdfContent = usePdfContent<PersonalDataInterface>({
    category: PdfCategory.SIGNATURE,
    templateType:
      location.pathname.slice(0, -1) === makePath(TPL_NEW_PERSONAL_DATA) ? TPL_NEW_PERSONAL_DATA : TPL_PERSONAL_DATA,
    ...params,
  });

  const data = pdfContent?.data ? pdfContent.data : ({} as PersonalDataInterface);
  const colors = useColorStyles({ code: pdfContent?.data?.header.signedVia || '' });
  const legal = pdfContent?.data && data.clientData.personType === PersonType.LEGAL;

  return pdfContent ? (
    <PdfContent errors={pdfContent?.errors} className={colors.root} onload afterLoad={params.afterLoad}>
      <Title>Změna osobních údajů</Title>

      <BasicData data={data.header} />

      <P>Žádám tímto o změnu níže vypsaných osobních údajů na všech mých podepsaných účtech v Edwardovi.</P>

      {legal ? (
        <CompanyData data={data.clientData as ContractLegalData} />
      ) : (
        <PersonalData data={data.clientData as ContractPhysicalData} />
      )}

      <H3 className="inLines">Bankovní spojení</H3>

      <BankAccounts legal={legal} data={data.clientData.bankData.bankAccounts} />

      {data.clientData.employerData?.employers.length && (
        <>
          <H3 className="inLines">Zaměstnavatelé</H3>
          <P>
            {data.clientData.employerData?.employers.map((e) => (
              <>
                {e.companyName}, IČO: {e.companyNumber}
                <br />
              </>
            ))}
          </P>
        </>
      )}

      {legal && (
        <>
          <Spacer variant="half" />
          <H2>Zástupce zákazníka:</H2>
          {'representative' in data.clientData && <PersonalData data={data.clientData.representative} />}
        </>
      )}

      <Signature protocol={data.signedInfo} />
    </PdfContent>
  ) : params.preview ? (
    <Loading />
  ) : null;
};

const TPL_PERSONAL_DATA: TemplateType = 'personalData';
const TPL_NEW_PERSONAL_DATA: TemplateType = 'newPersonalData';
export { TPL_PERSONAL_DATA, TPL_NEW_PERSONAL_DATA, NewPersonalData };
